<template>
  <b-card id="client-card">
    <template #header>
      <status-hero
        :variant="heroVariant"
        :title="heroTitle"
        :text="heroText"
      />
    </template>

    <div class="mt-4">
      <client-details v-if="clientOnlineCheckinCompleted" />
      <client-form v-else />
    </div>
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import ClientDetails from '@/views/foravila/bookings/booking/components/checkin/ClientDetails.vue'
import ClientForm from '@/views/foravila/bookings/booking/components/checkin/ClientForm.vue'
import StatusHero from '@/views/foravila/bookings/booking/components/checkin/StatusHero.vue'

export default {
  components: {
    BCard,
    StatusHero,
    ClientDetails,
    ClientForm,
  },
  computed: {
    client() {
      return this.$store.getters['client/client']
    },
    clientOnlineCheckinCompleted() {
      return this.$store.getters['booking/clientOnlineCheckinCompleted']
    },
    guestsOnlineCheckinCompleted() {
      return this.$store.getters['booking/guestsOnlineCheckinCompleted']
    },
    arrivalOnlineCheckinCompleted() {
      return this.$store.getters['booking/arrivalOnlineCheckinCompleted']
    },
    heroVariant() {
      return this.clientOnlineCheckinCompleted ? 'success' : 'warning'
    },
    heroTitle() {
      const clientName = this.client?.firstName || null

      if (!clientName) return 'Hola'

      return this.clientOnlineCheckinCompleted
        ? this.$t('pages.booking.checkin.thanksALotName', { name: clientName })
        : this.$t('pages.booking.checkin.holaName', { name: clientName })
    },
    heroText() {
      if (!this.clientOnlineCheckinCompleted) {
        return this.$t('pages.booking.checkin.completeClientInformation')
      }

      if (!this.guestsOnlineCheckinCompleted) {
        return this.$t('pages.booking.checkin.clientInformationCompletedNowGuests')
      }

      if (!this.arrivalOnlineCheckinCompleted) {
        return this.$t('pages.booking.checkin.clientInformationCompletedNowArrival')
      }

      return this.$t('pages.booking.checkin.clientInformationCompleted')
    },
  },
}
</script>

<style lang="scss">
#client-card {
  .card-header {
    padding: 0 !important;
  }
}
</style>
